import { render, staticRenderFns } from "./exibir-fale-com-a-gente.vue?vue&type=template&id=51846efa&"
import script from "./exibir-fale-com-a-gente.vue?vue&type=script&lang=ts&"
export * from "./exibir-fale-com-a-gente.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins-hml/workspace/pracessivel-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51846efa')) {
      api.createRecord('51846efa', component.options)
    } else {
      api.reload('51846efa', component.options)
    }
    module.hot.accept("./exibir-fale-com-a-gente.vue?vue&type=template&id=51846efa&", function () {
      api.rerender('51846efa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/fale-com-a-gente/exibir-fale-com-a-gente.vue"
export default component.exports